export default "__VITE_ASSET__BHoSxQPy__"